<template>
  <v-card-text>
    <v-row>
      <v-col>
        <v-row>
          <!--      <core-upload-card-body-radio title="Material" :data="material" />-->
          <v-col cols="auto">
            <span class="subtitle-2">
              Material
            </span>
            <v-radio-group
              v-model="localValue.material"
              row
              @change="localValue.serial = ''"
            >
              <v-radio
                v-for="(material, i) in materials"
                :key="i"
                :label="material.kind"
                :value="material.kind"
              />
            </v-radio-group>
          </v-col>

          <v-col cols="auto">
            <span class="subtitle-2">Series</span>
            <v-select
              v-model="localValue.serial"
              :items="serials"
              item-text="serial"
              item-value="serial"
              @change="localValue.thickness = ''"
            />
          </v-col>
        </v-row>

        <v-row>
          <!--      <core-upload-card-body-radio title="Finish" :data="finish" />-->
          <v-col cols="auto">
            <span class="subtitle-2">
              Finish
            </span>
            <v-radio-group
              v-model="localValue.finish"
              row
            >
              <v-radio
                v-for="(finish, i) in finishes"
                :key="i"
                :label="finish"
                :value="finish"
              />
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="auto">
            <span class="subtitle-2">Thickness</span>
            <v-select
              v-model="localValue.thickness"
              :items="thicknesses"
              item-text="thickness"
              item-value="thickness"
              suffix="mm"
            />
          </v-col>
        </v-row>
      </v-col>

      <!-- <v-col>
        <v-row>
          <v-col cols="6">
            <span class="subtitle-2">My revision</span>
            <v-text-field
              v-model="localValue.revision"
              full-width
              class="pt-0"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <span class="subtitle-2">My description</span>
            <v-text-field
              v-model="localValue.description"
              full-width
              class="pt-0"
            />
          </v-col>
        </v-row>
      </v-col> -->
    </v-row>
  </v-card-text>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModelableMixin from '../../mixins/modelable';

export default {
  mixins: [
    ModelableMixin,
  ],

  data: () => ({
    finishes: [
      'None', 'Clear Zinc', 'Protective Oil', 'Ecoating'
    ],
  }),

  computed: {
    ...mapGetters('materials', {
      find: 'find',
    }),

    materials() {
      return this.find({ query: {} }).data;
    },

    serials() {
      return _.get(
        _.find(this.materials, m => m.kind === this.localValue.material),
        'serials',
        [],
      );
    },

    thicknesses() {
      return _.get(
        _.find(this.serials, s => s.serial === this.localValue.serial),
        'thicknesses',
        [],
      );
    },
  },

  watch: {
    'localValue.material': {
      handler() {
        this.localValue.serial = '';
        this.localValue.thickness = '';
      },
    },

    'localValue.series': {
      handler() {
        this.localValue.thickness = '';
      },
    },
  },
};
</script>
